export const STATUS = {
  PLANTED: "planted",
  HARVESTED: "harvested",
  DISCARDED: "discarded",
};

export const STATUS_LABEL = {
  [STATUS.PLANTED]: "Planted",
  [STATUS.HARVESTED]: "Harvested",
  [STATUS.DISCARDED]: "Discarded",
};

// Filter-only values (not actual row statuses)
export const STATUS_FILTER_ALL = "All";
export const STATUS_FILTER_UNSAVED = "unsaved";
